import { buildClauseFromGroup } from './clauseBuilder.ts';
import { or, type WhereCondition } from './filterHelpers.ts';

export const buildDirectProviderFilters = (accountId: string, providerId?: string): WhereCondition | null => {
  if (!providerId) return null;

  const directGroups = [
    { category: 'direct', provider_id: providerId, account_id: accountId },
    { category: 'direct', account_id: accountId, sub_category: 'uploaded' },
  ];

  const directClauses = directGroups.map(grp => buildClauseFromGroup(grp));

  return or(...directClauses);
};
